module.exports = __webpack_public_path__ + "assets/img/lg3.2af8a7cf.png";